
import { ERoleDepartmentPermission, IRoleTreeItem } from '../../types/common';
import { EAxiosResponseCode, ESystemType, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 系统配置 - 默认角色列表
 * @param systemType 端类型 {@link ESystemType}
 */
export async function querySystemRoleList(systemType: ESystemType) {
  let data = [] as IRoleTreeItem[];

  try {
    const { code, context, message } = await Http.get<IRoleTreeItem[]>(`${hostUrl}/iam/role/init`, { systemType });

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IRoleTreeItem[];

      data = items || [] as IRoleTreeItem[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 系统配置 - 新增默认角色
 */
export async function insertSystemRole(params: {systemType: 1 | 2 | 3; roleName: string}) {

  try {
    const { code, message } = await Http.post<{systemType: 1 | 2 | 3; roleName: string}>(`${hostUrl}/iam/role/init`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 系统配置 - 编辑默认角色
 */
export async function updateSystemRole(params: {roleId: number; roleName: string}) {

  try {
    const { code, message } = await Http.put<{roleId: number; roleName: string}>(`${hostUrl}/iam/role/init/name`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 系统配置 - 删除默认角色
 */
export async function deleteSystemRole(roleId: number) {

  try {
    const { code, message } = await Http.delete<{roleId: number}>(`${hostUrl}/iam/role/init?roleId=${roleId}`);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 系统配置 - 保存配置
 */
export async function saveSystemRole(params: {roleId: number; menuIds: number[]; dataPermission: ERoleDepartmentPermission}) {

  try {
    const { code, message } = await Http.put<{roleId: number; menuIds: number[]; dataPermission: ERoleDepartmentPermission}>(`${hostUrl}/iam/role/init/menu`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
